import React, { forwardRef } from 'react';
import { Interrogation } from 'assets/icons';

const body = {
  info: 'bg-[#EFF6FF]',
  disabledInfo: '',
  warning: 'bg-[#FFF6EB]',
  alert: 'bg-[#FEF2F2]',
};

const content = {
  info: 'text-blue-700',
  disabledInfo: 'text-blue-700 underline underline-offset-2',
  warning: 'text-yellow-700',
  alert: 'text-red-700',
};

const InterrogationColors = {
  info: '#60A5FA',
  warning: '#FFA43D',
  alert: '#F87171',
  disabledInfo: '#60A5FA',
};

const Banner = forwardRef(({ type, children }, ref) => (
  <div
    ref={ref}
    className={`${body[type]} corner-smooth-8`}
    style={{ padding: '10px 16px' }}
    role="alert"
  >
    <div className="flex items-center justify-start gap-2">
      <div className="flex">
        <Interrogation color={InterrogationColors[type]} wh="20" strokeW="2" />
      </div>
      <p
        className={`${content[type]} block sm:inline font-normal`}
        style={{ fontSize: '14px', lineHeight: '20px' }}
      >
        {children}
      </p>
    </div>
  </div>
));

export default Banner;
